export default "<div id=\"dashboard-analytics\" class=\"page-layout blank\">\n\n    <p>Dashboard</p>\n\n</div>"